import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OrchestraMatrix.html?raw';
import connect from 'dojo/_base/connect';
import domGeom from 'dojo/dom-geometry';
import query from 'dojo/query';
import on from 'dojo/on';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import "../../moreCore/UI/SelectBox/SelectBox";
import "../../moreCore/UI/Button/Button";

import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import WeekSelector from '../WeekSelector/WeekSelector';
import SubstituteManager from '../SubstituteManager/SubstituteManager';

import LoadedCalendarWeek from '../SharedTypes/LoadedCalendarWeek';
import SelectionStateManager from '../SelectionStateManager/SelectionStateManager';
import FileTileWidget from '../DashboardWidgets/FileTileWidget';

import "../SharedTypes/mixed";

class OrchestraMatrix extends compose(_WidgetBaseSP) {
	templateString: any = template;

	selectionValueSelector: MdsLax<InstanceType<typeof SelectBox>>;

	dataStatusLabel: HTMLSpanElement;
	y_Axis: HTMLDivElement;
	y_Axis_ScrollContainer: HTMLDivElement;
	x_Axis: HTMLDivElement;
	x_Axis_ScrollContainer: HTMLDivElement;
	viewPortNode: HTMLDivElement;
	containerNode: HTMLDivElement;

	selectionValue: SelectionValueEntity = null;
	weekSelector: MdsLax<InstanceType<typeof WeekSelector>>;
	substituteManager: MdsLax<InstanceType<typeof SubstituteManager>>;
	fileTileWidget: MdsLax<InstanceType<typeof FileTileWidget>>;

	__opacityTimeout: number;
	__scrollTimeout: number;

	_mousePressActive: boolean = false;
	_lastMouseactiveCellEntry: cellEntry = null;

	readonly: boolean = false;

	loadedWeekIds: Array<string> = new Array<string>();
	loadedWeekObjects: Array<LoadedCalendarWeek> = new Array<LoadedCalendarWeek>();

	maxRows: number = 0;
	maxCells: number = 0;
	cellHeight: number = 35;
	cellWidth: number = 35;
	cellBorder: object = {
		"left": 0,
		"right": 1,
		"top": 1,
		"bottom": 0,
		"color": "gray",
		"style": "dotted"
	};
	cellBorderBold: object = {
		"left": 0,
		"right": 1,
		"top": 1,
		"bottom": 0,
		"color": "black",
		"style": "solid"
	};
	colors: object = { // farben der Contentcells
		"entity": "#FFFFFF",
		"group": "#ededeb"
	};
	OpacityScroll: boolean = false; // abblenden während dem Scrollen

	_data_Content: ItemContainer<DataItem_Content>;
	_data_X: ItemContainer<DataItem_X>;
	_data_Y: ItemContainer<DataItem_Y>;
	_data_SelectionValues: Array<SelectionValueEntity>;

	_registry: Array<rowEntry> = new Array<rowEntry>();
	_cellRegistry: Array<cellEntry> = new Array<cellEntry>();
	_registry_X: Array<DataItem_X> = new Array<DataItem_X>();
	_registry_Y: Array<DataItem_Y> = new Array<DataItem_Y>();

	_nodeToDataItem: Array<{ node: HTMLElement, item: DataItem }> = [];

	_visibleIDs_X: Array<string> = new Array<string>();
	_visibleIDs_Y: Array<string> = new Array<string>();

	_visibleItems_X: Array<DataItem_X> = new Array<DataItem_X>();
	_visibleItems_Y: Array<DataItem_Y> = new Array<DataItem_Y>();

	_nodes_X: Array<HTMLElement> = new Array<HTMLElement>();
	_nodes_Y: Array<HTMLElement> = new Array<HTMLElement>();

	selectionStateManager: MdsLax<InstanceType<typeof SelectionStateManager>>;

	directBookingId: string;
	directProjectId: string;

	mainMenuGlobalSpaceNode: HTMLElement;

	private _collapsedItems_Y: Array<{ node: HTMLElement, item: DataItem }> = [];
	private _collapsedItems_X: Array<DataItem> = [];

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

		this.RequestManager.handleAs = "json";
		this.refreshViewPortContent();

		this._subscriptions.push({
			handle: connect.connect(window, "resize", this, "refreshViewPortContent"),
			topic: "windowResize"
		});
		//this.loadData();

		if (this.mainMenuGlobalSpaceNode == null) {
			this.mainMenuGlobalSpaceNode = document.getElementById("mainMenuGlobalSpace");
		}

	}

	getScrollOffsetIndex_X(): number {
		let firstVisibleItem = (this._visibleItems_X ?? [])[0];
		return this._registry_X.indexOf(firstVisibleItem);
	}

	getScrollOffsetIndex_Y(): number {
		let firstVisibleItem = (this._visibleItems_Y ?? [])[0];
		return this._registry_Y.indexOf(firstVisibleItem);
	}

	_onClick_SubstituteManagerButton(): void {
		this.openSubstituteManager();
	}

	openSubstituteManager(): void {
		this.substituteManager = new SubstituteManager();
		this.substituteManager.calendarWeeks = this.loadedWeekObjects;

		let dlg = new GenericDialog();
		dlg.set("header", this.getTranslation("OM_Matrix__Btn_EditSubstitutes"));
		dlg.set("okBtn", true);
		dlg.set("CancelBtn", true);
		dlg.set("TopCloseBtn", true);
		dlg.set("callback", lang.hitch(this, this._onSubstituteManagerCallback));
		dlg.closeOnEnter = true;
		dlg.addNodeToContent(this.substituteManager.domNode);

		//this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "400px");
		//this.UiModder.domStyle.set(dlg.modalDlgContentNode, "top", "20px");


		dlg.show();
		this.substituteManager.startup();
	}

	_onSubstituteManagerCallback(result: number): void {
		if (result == 1) {
			this.openWeekSelector(); // wenn beim Substitutenmanager auf Ok geklickt wurde, dann nochmal die Daten neu laden weil vermutlich neue Musiker hinzugefügt wurden
		}
    }

	_onClick_WeekSelectorButton(): void {
		//console.log("_onClick_WeekSelectorButton");

		this.openWeekSelector();
	}

	openWeekSelector(): void {
		this.weekSelector = new WeekSelector(this.directBookingId, this.directProjectId);

		let dlg = new GenericDialog();
		dlg.set("header", this.getTranslation("OM_Matrix__ChooseYourParameters"));
		dlg.set("okBtn", true);
		dlg.set("CancelBtn", true);
		dlg.set("TopCloseBtn", true);
		dlg.set("callback", lang.hitch(this, this._onWeekSelectorCallback));
		dlg.closeOnEnter = true;
		dlg.addNodeToContent(this.weekSelector.domNode);

		this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "400px");
		this.UiModder.domStyle.set(dlg.modalDlgContentNode, "top", "20px");

		//	Modal-Dlg mittig platzieren
		//
		//this.UiModder.domStyle.set(dlg.modalDlgContentNode, "top", "30%");


		dlg.show();
		this.weekSelector.startup();
    }

	_onWeekSelectorCallback(result: number) {
		if (result == 1) {
			var filterMode = this.weekSelector.RadioGroup_timeFilterMode.getValue() as string;
			let weekId: string = null;
			let monthId: string = null;

			if (filterMode == "weeks") {
				// woche(n)
				weekId = this.weekSelector.SelectBox_week.getValue();
				if (weekId == null || weekId == "") {
					this.openWeekSelector();
					return;
				}
			} else {
				// monat
				monthId = this.weekSelector.SelectBox_month.getValue();
				if (monthId == null || monthId == "") {
					this.openWeekSelector();
					return;
				}
			}

			// functionsgruppe
			let functionalGroupIs: string = this.weekSelector.SelectBox_functionalGroups.getValue();
			if (functionalGroupIs == null || functionalGroupIs == "") {
				this.openWeekSelector();
				return;
			}

			if (this.weekSelector.directBookingId || this.directBookingId) {
				filterMode = "booking";
			}

			if (this.weekSelector.directProjectId || this.directProjectId) {
				filterMode = "project";
            }

			this.loadData(filterMode, weekId, monthId, functionalGroupIs, this.directBookingId ? this.directBookingId : this.weekSelector.directBookingId, this.directProjectId ? this.directProjectId : this.weekSelector.directProjectId);
		}
		this.weekSelector.destroy();
		this.weekSelector = null;
    }

	loadData(filterMode: string, weekId: string, monthId: string, functionalGroupIs: string, directBookingId: string, directProjectId: string): void{
		this.StandbyStart();
		this.clear();
		//this.load_Content();
		this.load_X(filterMode, weekId, monthId, functionalGroupIs, directBookingId, directProjectId);
		this.load_Y(functionalGroupIs, filterMode, weekId, monthId, directBookingId, directProjectId);
		this.load_SelectionValues();
	}

	checkLoadingState(): void {

		if (this._data_Content == null && this._data_X != null && this._data_Y != null) {
			// X und Y vorhanden, aber content fehlt noch
			this.load_Content();
			return;
		}

		if (this._data_Content != null && this._data_X != null && this._data_Y != null) {
			// alles vorhanden. dann kann mit dem initialien zeichnen der DAten begonnen werden
			this.calcVisibleIds();
			this.mapDataToViewPort();
			this.refreshViewPortContent();
			this.StandbyStop();

			this.y_Axis.scrollTop = 0;
		}
	}

	_onClick_LoadContentCellsButton(): void{
		this.StandbyStart();
		this.load_Content();
	}

	selectionStateManager_Rollback(): void {
		if (confirm(this.getTranslation("OM_Matrix__RollbackMsg"))) {
			this.StandbyStart();
			this.load_Content();

			this.selectionStateManager.ClearStack();
		}
	}
	selectionStateManager_BeforeCommit(): void {
		this.StandbyStart();
    }

	selectionStateManager_Commit(result: boolean): void {
		if (result == true) {
			this.selectionStateManager.ClearStack();

			this.load_Content();
		}

		this.StandbyStop();
    }


	private __load_Content_InProgress: boolean = false;

	load_Content(): void {

		if (this.__load_Content_InProgress == true) {
			return;
        }

		this.__load_Content_InProgress = true;
		let requestData: object = {
			"IDsX": this._getAxisIDs(this._registry_X),
			"IDsY": this._getAxisIDs(this._registry_Y),
		};

		let url = window.appRoot + "data/ContentCells";
		this.RequestManager.post(url,
			{
				"JsonData": JSON.stringify(requestData)
			},
			lang.hitch(this, function (response) {
				this.__load_Content_InProgress = false; // inline wahnsinn!!!!!
				this._data_Content = response;
				this._processData_Content();
			}), function (err) {
				this.__load_Content_InProgress = false;
			}
		);
	}

	_getAxisIDs(axisRegistry: Array<DataItem_Axis>): Array<string> {
		let resultList: Array<string> = new Array<string>();

		for (let i = 0; i < axisRegistry.length; i++) {
			let entry: DataItem_Axis = axisRegistry[i];

			if (entry.type == "entity") { // braucht man das?? eventuell blöd bei Summenzeilen
				resultList.push(entry.ID);
			}
		}

		return resultList;
    }

	_processData_Content(): void{
		/*this.UiModder.domAttr.set(this.dataStatusLabel, {
			"innerHTML": "content data loaded",
			"style": {
				"color": "green"
			}
		});*/
		this.UiModder.domClass.add(this.dataStatusLabel, "w3-hide");

		this.checkLoadingState();
	}

	load_SelectionValues(): void {
		let url = window.appRoot + "data/selectionvalues";
		this.RequestManager.get(url,
			lang.hitch(this, this._processSelectionValues),
			function (err) {
				alert(JSON.stringify(err));
			}
		);
	}

	_processSelectionValues(items: Array<SelectionValueEntity>) {
		this._data_SelectionValues = items;
		if (this.selectionValueSelector.entries.length == 0) {
			for (let entity of this._data_SelectionValues) {
				this.selectionValueSelector.addOption(entity.ID, entity.code, true);
			}
		}

		this.selectionValueSelector.startup();
		this.refreshSelectionValue();
	}

	getSelectionValueEntityByID(ID: string) {
		for (let entity of this._data_SelectionValues) {
			if (entity.ID == ID) {
				return entity;
            }
		}
		return null;
    }

	load_Y(functionalGroupIs: string, filterMode: string, weekId: string, monthId: string, directBookingId: string, directProjectId: string): void {

		let url = window.appRoot + "data/Y";
		this.RequestManager.post(url,
			{
				"JsonData": JSON.stringify({
					"functionalGroupIs": functionalGroupIs,
					"functionalGroupIds": functionalGroupIs,
					"functionalGroupId": functionalGroupIs,
					"week": weekId,
					"filterMode": filterMode,
					"monthId": monthId,
					"directBookingId": directBookingId,
					"directProjectId": directProjectId
				})
			},
			lang.hitch(this, function (response) {
				this._data_Y = response;
				this._processData_Y();
				this.checkLoadingState();
			}), function (err) { alert(JSON.stringify(err)); }
		);
	}

	_redrawY(): void {
		this._registry_Y = [];

		this.UiModder.domConstruct.empty(this.y_Axis);
		this.UiModder.domConstruct.empty(this.y_Axis_ScrollContainer);

		this._processData_Y();
	}

	private _adjustCollapsableIcon(iconNode: HTMLElement, collapsed: boolean) {

		if (!iconNode) {
			return;
		}

		if (this.UiModder.domClass.contains(iconNode, "collapseIconX")) {
			if (collapsed == true) {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-right");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-left");
			} else {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-left");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-right");
			}
		} else if (this.UiModder.domClass.contains(iconNode, "collapseIconY")) {
			if (collapsed == true) {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-top");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-down");
			} else {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-down");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-top");
			}
		}
	}

	// click vertial (auf-/zuklappen)
	//
	_onClick_yItem(item: DataItem_Y, node: HTMLElement, evt: Event) {
		console.log("_onClick_yItem", item);

		let iconNode = node.getElementsByClassName("collapseIconX")[0];
		//console.log("iconNode", iconNode);

		if (item.type == "group") {

			let groupItems: Array<DataItem> = [];

			for (let i = 0; i < this._nodeToDataItem.length; i++) {
				let entry = this._nodeToDataItem[i];

				if (entry.item["groupID"] == item.ID) {
					groupItems.push(entry.item);

					let alreadyHidden = this.isNodeHidden(entry.node);

					if (alreadyHidden === true) {
						let index = this._collapsedItems_Y.indexOf(entry);
						this._collapsedItems_Y.splice(index, 1);

						entry.item.invisible = false;
					} else {
						this._collapsedItems_Y.push(entry);
						entry.item.invisible = true;

					}

					this.hideNode(entry.node, entry.item.invisible);
				}
			}

			//this.mapDataToViewPort();
			this.refreshViewPortContent();
			//console.log("groupItems", groupItems);

			this._adjustCollapsableIcon(iconNode as HTMLElement, groupItems[0].invisible == true);
		}
	}

	_onClick_xAxis(item: DataItem_X, node: HTMLElement, evt): void {
		console.log("_onClick_xAxis", item);

		let iconNode = node.getElementsByClassName("collapseIconX")[0];
		console.log("iconNode", iconNode);

		if (item.type == "group") {

			let groupItems = [];

			this._registry_X
			for (let i = 0; i < this._registry_X.length; i++) {
				let subItem = this._registry_X[i];
				let node = this._nodes_X[i];

				if (subItem["groupID"] == item.ID) {
					groupItems.push(subItem);

					let alreadyHidden = this.isNodeHidden(node);

					if (alreadyHidden === true) {
						let index = this._collapsedItems_X.indexOf(subItem);
						this._collapsedItems_Y.splice(index, 1);

						subItem.invisible = false;
					} else {
						this._collapsedItems_X.push(subItem);
						subItem.invisible = true;

					}


					this.hideNode(node, subItem.invisible);
				}
			}

			//this._adjustCollapsableIcon(iconNode as HTMLElement, groupItems[0].invisible == true);
			this.refreshViewPortContent();
			console.log("groupItems", groupItems);
		}

	}

	_onClick_xAxis__OLD(dataItem: DataItem_X, evt): void {
		//console.log("_onClick_xAxis", dataItem.entityClassname, dataItem.entityID, dataItem);
		this._lastOnClick_DataItem = dataItem;

		if (this._onClick_Dlg != null) {
			this._onClick_Dlg.destroy();
			this._onClick_Dlg = null;
		}

		if (dataItem.entityClassname != "calendarweek" && dataItem.entityClassname != "ev_projects" && dataItem.entityClassname != "month") {
			return;
		}

		this._onClick_Dlg = new GenericDialog();
		this._onClick_Dlg.set("header", dataItem.label);
		this._onClick_Dlg.set("okBtn", false);
		this._onClick_Dlg.set("CancelBtn", false);
		this._onClick_Dlg.set("TopCloseBtn", true);
		//dlg.set("content", `${dataItem.entityClassname} - ${dataItem.entityID}`);

		this._onClick_Dlg.closeOnEnter = true;

		this.fileTileWidget = new FileTileWidget()
		let value;
		switch (dataItem.entityClassname) {
			case "ev_projects":
				value = "PP";
				break;
			case "month":
				value = "MP";
				break;
			case "calendarweek":
				value = "WP"
				break;
		}



		let reportObj = {
			selectedReport: value,
			dateFrom: dataItem["dateFrom"],
			dateTo: dataItem["dateTo"],
		}

		//this.fileTileWidget.on("requestFile", lang.hitch(this, this.fileTileWidget._onFileRequestedByManager));

		this.fileTileWidget.applyDashboardWidgetParams(reportObj)

		this._onClick_Dlg.addNodeToContent(this.fileTileWidget.domNode);

		this._onClick_Dlg.show();
	}

	_processData_Y(): void{
		//	Zeichnen der Zeilen (vertikal)
		//
		//let paddingLeft = 0;
		this._nodes_Y = new Array<HTMLElement>();

		let lastType = null;
		for (let i = 0; i < this._data_Y.items.length; i++) {

			let currentType = this._data_Y.items[i].type;
			let nextType = this._data_Y.items[i+1]?.type;

			////	beim Wechsel von Entity auf Gruppe den Einzug zurücksetzen
			////
			//if (currentType == "group" && lastType == "entity") {
			//	paddingLeft = 0;
			//}

			let icon = "";
			if (currentType == "group" && nextType == "entity") {
				icon = `<i class="fas fa-chevron-circle-up collapseIconY"></i>&nbsp;`;
			}

			let node = this.UiModder.domConstruct.create("div", {
				"innerHTML": icon + this._data_Y.items[i].label,
				"style": {
					"height": (this.cellHeight + this.getCellBorderHeight()) + "px",
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBorderStyleString("right"),
					"borderTop": this.getCellBorderStyleString("top"),
					"borderBottom": this.getCellBorderStyleString("bottom"),
					"backgroundColor": (typeof (this._data_Y.items[i].color) == "string" ? this._data_Y.items[i].color : this.colors[currentType]),
					"paddingLeft": (currentType == "entity") ? "16px" : "4px"
				}
			}, this.y_Axis);

			on(node, "click", lang.hitch(this, this._onClick_yItem, this._data_Y.items[i], node));

			this._nodes_Y.push(node);
			this._registry_Y.push(this._data_Y.items[i]);
			this._nodeToDataItem.push({
				node: node,
				item: this._data_Y.items[i]
			});

			// dummy-node in scrollcontainer erstellen
			// 	y_Axis_ScrollContainer hat einen Inhalt der gleich groß ist wie der Inhalt von y_Axis. Jedoch ist de Inhalt von y_Axis_ScrollContainer unsichtbar und dient nur dazu um einen Scrollbalken zu zeichnen
			//	die Scrollposition von y_Axis_ScrollContainer wird dann auf y_Axis übertragen
			//
			this.UiModder.domConstruct.create("div", {
				"innerHTML": "dummy",
				"style": {
					"height": (this.cellHeight + this.getCellBorderHeight()) + "px",
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBorderStyleString("right"),
					"borderTop": this.getCellBorderStyleString("top"),
					"borderBottom": this.getCellBorderStyleString("bottom"),
					"visibility": "hidden"
				}
			}, this.y_Axis_ScrollContainer);

			////	nach jeder gruppe den linken Einzug vergrößern
			////
			//if (currentType == "group") {
			//	paddingLeft += 16;
			//}

			lastType = currentType;
		}

		this.checkLoadingState();
	}

	load_X(filterMode: string, weekId: string, monthId: string, functionalGroupIs: string, directBookingId: string, directProjectId: string): void {
		let url = window.appRoot + "data/X";
		this.RequestManager.post(url,
			{
				"JsonData": JSON.stringify({
					"week": weekId,
					"filterMode": filterMode,
					functionalGroupIds: functionalGroupIs,
					functionalGroupIs: functionalGroupIs,
					functionalGroupId: functionalGroupIs,
					"monthId": monthId,
					"directBookingId": directBookingId,
					"directProjectId": directProjectId
				})
			},
			lang.hitch(this, function (response) {
				this._data_X = response;
				this._processData_X();
			}), function (err) { alert(JSON.stringify(err)); }
		);
	}

	_processData_X(): void {
		//	Zeichnen der Spalten (horizontal)
		//
		let createdCells = [];
		let width = 0;

		let segmentLineNode: HTMLDivElement = null;
		let segmentNode: HTMLDivElement = null;
		if (this._data_X.segmentLinePosition != null) { // segmente werden verwendet
			// container der segmente
			segmentLineNode = this.UiModder.domConstruct.create("div", { }) as HTMLDivElement;
			// erstes segment gleich erstellen
			segmentNode = this.UiModder.domConstruct.create("div", { "className": "w3-cell daygroupTop", "innerHTML": "&nbsp;" }, segmentLineNode) as HTMLDivElement;

		}
		// segment-line on top?
		//
		if (this._data_X.segmentLinePosition == "top") {
			this.UiModder.domConstruct.place(segmentLineNode, this.x_Axis);
        }

		let segment_1_text_old: string = undefined;
		let segmentItemCounter: number = 0;
		let segmentNodeOutputCounter = 0;

		for (let i = 0; i < this._data_X.items.length; i++) {
			let currentType = this._data_X.items[i].type;
			let nextType = this._data_X.items[i + 1]?.type;

			//	kalenderwoche des termins merken
			//
			let calendarWeekID = this._data_X.items[i].ref_sys_calendarweek;
			if (typeof (calendarWeekID) != "undefined") {
				if (this.loadedWeekIds.indexOf(calendarWeekID) == -1) {
					this.loadedWeekIds.push(calendarWeekID);
					this.loadedWeekObjects.push({
						"ID": calendarWeekID,
						"label": this._data_X.items[i].ref_sys_calendarweek__label
					});
				}
			}

			if (this._data_X.segmentLinePosition != null) { // segmente werden verwendet
				// das alte segment ist zu ende und ein neues muss erstellt werden
				if (segment_1_text_old != this._data_X.items[i].segment_1_text) {
					segmentNode = this.UiModder.domConstruct.create("div", {
						"innerHTML": this._data_X.items[i].segment_1_text == undefined ? "" : this._data_X.items[i].segment_1_text,
						"className": "w3-cell daygroupTop"
					}, segmentLineNode) as HTMLDivElement;
					segmentItemCounter = 1;
					segmentNodeOutputCounter++;
				} else {
					segmentItemCounter++;
				}

				let additionalWidth = 0;

				if (segmentNodeOutputCounter == 0) {
					additionalWidth = 1;
				}
				let segmentWidth = (this.cellWidth * segmentItemCounter) + additionalWidth + "px";

				this.UiModder.domStyle.set(segmentNode, {
					"width": segmentWidth,
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBoldBorderStyleString("right")
				});
			}

			let icon = "";
			if (currentType == "group" && nextType == "entity") {
				icon = `<i class="fas fa-chevron-circle-left collapseIconY"></i>&nbsp;`;
			}

			let cell = this.UiModder.domConstruct.create("div", {
				"innerHTML": icon + this._data_X.items[i].label,
				"class": "matrixCell_TOP_X flex_row_center",
				"style": {
					//"height": "90%",
					"width": this.cellWidth + "px",
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBorderStyleString("right"),
					"backgroundColor": (typeof (this._data_X.items[i].color) == "string" ? this._data_X.items[i].color : this.colors[currentType]),
					"overflow": "hidden",
					"textOverflow": "ellipsis"
				}
			}, this.x_Axis);

			on(cell, "click", lang.hitch(this, this._onClick_xAxis, this._data_X.items[i], cell));

			createdCells.push(cell);

			width += (this.cellWidth + this.getCellBorderWidth());
			this._registry_X.push(this._data_X.items[i]);

			segment_1_text_old = this._data_X.items[i].segment_1_text;
		}

		this._nodes_X = createdCells;

		// segment-line bottom?
		//
		if (this._data_X.segmentLinePosition == "bottom") {
			this.UiModder.domConstruct.place(segmentLineNode, this.x_Axis);
		}

		// gesamte Container-Breite auf die Summe der Spalten-Breite anpassen
		this.UiModder.domStyle.set(this.x_Axis, {
			"width": width + "px"
		});

		if (this._data_X.segmentLinePosition == "bottom") {
			this.x_Axis_ScrollContainer.scrollTop = 200;
		}

		this.checkLoadingState();
	}

	_lastOnClick_DataItem: DataItem_X;
	_onClick_Dlg: MdsLax<InstanceType<typeof GenericDialog>>;

	clear(): void {
		this.UiModder.domConstruct.empty(this.x_Axis);
		this._registry_X = new Array<DataItem_X>();

		this.UiModder.domConstruct.empty(this.y_Axis);
		this.UiModder.domConstruct.empty(this.y_Axis_ScrollContainer);
		this._registry_Y = new Array<DataItem_Y>();
		this._cellRegistry = new Array<cellEntry>();

		this._data_Content = null;
		this._data_X = null;
		this._data_Y = null;

		this._visibleIDs_X = null;
		this._visibleIDs_Y = null;

		this._visibleItems_X = null;
		this._visibleItems_Y = null;

		this.loadedWeekIds = new Array<string>();
		this.loadedWeekObjects = new Array<LoadedCalendarWeek>();
	}

	blurAllGroupContentCells(): void {
		return;
		for (let cellEntry of this._cellRegistry) {
			if (cellEntry.entity != null) {
				if (cellEntry.entity.static === true) {
					continue; // no blur for static entries
				}
			}

			if (cellEntry.type == "group") {
				this.UiModder.domStyle.set(cellEntry.cellNode, "filter", "blur(2px)");
			}
		}
	}

	calcVisibleIds(): void {
		this.calcVisibleIds_X();
		this.calcVisibleIds_Y();
	}

	calcVisibleIds_X(startIndex?): void {
		if (typeof (startIndex) == "undefined") {
			startIndex = 0;
		}

		this._visibleIDs_X = [];
		this._visibleItems_X = [];
		for (let i = 0; i < this._registry_X.length; i++) {
			if (i >= startIndex && i <= startIndex + this.maxCells) {
				this._visibleIDs_X.push(this._registry_X[i].ID);
				this._visibleItems_X.push(this._registry_X[i]);
			}
		}
	}
	calcVisibleIds_Y(startIndex?): void {
		if (typeof (startIndex) == "undefined") {
			startIndex = 0;
		}

		this._visibleIDs_Y = [];
		this._visibleItems_Y = [];
		for (let i = 0; i < this._registry_Y.length; i++) {
			if (i >= startIndex && i <= startIndex + this.maxRows) {
				this._visibleIDs_Y.push(this._registry_Y[i].ID);
				this._visibleItems_Y.push(this._registry_Y[i]);
			}
		}
	}

	refreshViewPortContent(): void {
		if (this._destroyed == true){
			return; //FIXME - nach destroyed triggered on re-size trotzdem irgendwo noch ein event...
		}
		// Container leeren
		this.destroyAllRows();

		// breite vom ViewPort auslesen
		//
		let viewPortWidth = this.getViewPortSize().w;
		this.UiModder.domStyle.set(this.x_Axis_ScrollContainer, "width", (viewPortWidth + 20) + "px");

		// Maximale Anzahl Zeilen/Spalten berechnen
		this.maxRows = (this.getViewPortSize().h - 100) / (this.cellHeight + this.getCellBorderHeight());
		this.maxCells = this.getViewPortSize().w / (this.cellWidth + this.getCellBorderWidth());

		this.calcVisibleIds();

		let containerHeight = 0;
		let containerWidth = 0;

		this._registry = [];
		this._cellRegistry = new Array<cellEntry>();

		// Zeilen erzeugen
		for (let rowIndex = 0; rowIndex < this.maxRows; rowIndex++) {

			containerWidth = 0;
			let rowNode = this.UiModder.domConstruct.create("div", {
				"class": "matrixRow",
				"style": {
					"height": (this.cellHeight + this.getCellBorderHeight()) + "px"
				}
			}, this.containerNode);

			let rowEntry: rowEntry = {
				"rowNode": rowNode as HTMLDivElement,
				"cells": []
			};

			this._registry.push(rowEntry); // row to registry

			// Spalten pro Zeile erzeugen
			for (let cellIndex = 0; cellIndex < this.maxCells; cellIndex++) {
				let cellNode = this.UiModder.domConstruct.create("div", {
					"class": "matrixCell",
					"style": {
						"width": this.cellWidth + "px",
						"height": this.cellHeight + "px",
						"borderLeft": this.getCellBorderStyleString("left"),
						"borderRight": this.getCellBorderStyleString("right"),
						"borderTop": this.getCellBorderStyleString("top"),
						"borderBottom": this.getCellBorderStyleString("bottom")
					}
				}, rowNode);

				let cellEntry: cellEntry = {
					"cellNode": cellNode as HTMLDivElement,
					"entity": null,
					"coordinatesVisible": { x: cellIndex, y: rowIndex }
				};

				rowEntry.cells.push(cellEntry); // cell to row
				this._cellRegistry.push(cellEntry);

				containerWidth += (this.cellWidth + this.getCellBorderWidth());
			}

			containerHeight += (this.cellHeight + this.getCellBorderHeight());
		}

		// Container auf Inhaltsgröße anpassen
		//
		this.UiModder.domStyle.set(this.containerNode, {
			"height": containerHeight + "px",
			"width": containerWidth + "px"
		});

		this.UiModder.domStyle.set(this.y_Axis, {
			"height": containerHeight + "px"
		});
		this.UiModder.domStyle.set(this.y_Axis_ScrollContainer, {
			"height": containerHeight + "px"
		});

		this.mapDataToViewPort();
	}

	_resetContentOpacity(): void{
		if (this.__opacityTimeout) {
			clearTimeout(this.__opacityTimeout);
		}
		this.__opacityTimeout = setTimeout(lang.hitch(this, function () {
			this.UiModder.domStyle.set(this.containerNode, "opacity", 1);
		}), 50);
	}

	getContentEntryByCellNode(cellNode): cellEntry {
		for (let rowIndex = 0; rowIndex < this._registry.length; rowIndex++) {
			for (let cellIndex = 0; cellIndex < this._registry[rowIndex].cells.length; cellIndex++) {
				let cellEntry = this._registry[rowIndex].cells[cellIndex];

				if (cellEntry.cellNode == cellNode) {
					return cellEntry;
				}
			}
		}
		return null;
	}

	_onChange_SelectionValueSelector(): void {
		this.refreshSelectionValue();
	}

	refreshSelectionValue(): void {
		this.selectionValue = this.getSelectionValueEntityByID(this.selectionValueSelector.getValue());
	}

	_onMouseDown_Content(evt): void {
		this._mousePressActive = true;
	}

	_onMouseUp_Content(evt): void {
		this._mousePressActive = false;

	}

	_onMouseMove_Content(evt): void {
		let cellNode = evt.target;
		let contentEntry = this.getContentEntryByCellNode(cellNode);
		if (this._mousePressActive == true) {

			//	Wenn mausklick aktiv und maus über contentcells bewegt wird, dann wird selektion ausgeführt
			//
			if (contentEntry != this._lastMouseactiveCellEntry) {
				this._lastMouseactiveCellEntry = contentEntry;

				this._handleContentCellSelection(contentEntry);
			}
		}

		if (contentEntry != null) {
			// X
			let visibleXNode = this._nodes_X[contentEntry.coordinatesVisible.x + this.getScrollOffsetIndex_X()];
			for (let node of this._nodes_X) {
				this.UiModder.domClass.remove(node, "boxShadow");
			}
			if (visibleXNode != null) {
				this.UiModder.domClass.add(visibleXNode, "boxShadow");
			}

			// Y
			let visibleYNode = this._nodes_Y[contentEntry.coordinatesVisible.y + this.getScrollOffsetIndex_Y()];
			for (let node of this._nodes_Y) {
				this.UiModder.domClass.remove(node, "boxShadow");
			}
			if (visibleYNode != null) {
				this.UiModder.domClass.add(visibleYNode, "boxShadow");
			}
        }

	}

	_handleContentCellSelection(contentEntry: cellEntry): void {
		let itemX: DataItem_X = this._visibleItems_X[contentEntry.coordinatesVisible.x];
		let itemY: DataItem_Y = this._visibleItems_Y[contentEntry.coordinatesVisible.y];
		if (itemX == null || itemY == null) {
			return;
		}
		if (itemX.type != "entity" || itemY.type != "entity") {
			return;
		}

		//this._data_Content.items
		//console.log("entity", contentEntry.entity);

		if (contentEntry.entity == null) {
			//	es gibt noch kein Entity auf der Zelle die geklickt wurde. daher erzeugen
			//
			contentEntry.entity = {
				ID: null,
				color: this.selectionValue.coloration.BackColor.Hex,
				label: this.selectionValue.code,
				ref_x: itemX.ID,
				ref_y: itemY.ID
			};

			this._data_Content.items.push(contentEntry.entity);

			this._handleContentSelection_Create(contentEntry.entity);
		} else {
			//	entity existiert schon. entfernen
			//
			this._handleContentSelection_Delete(contentEntry.entity);
			let indexInData = this._data_Content.items.indexOf(contentEntry.entity);
			this._data_Content.items.splice(indexInData, 1);
			contentEntry.entity = null;
			//delete contentEntry.entity;
		}

		this.mapDataToViewPort();
    }

	_onClick_Content(evt): void {
		if (this.readonly == true) {
			return;
        }

		//console.log("_onClick_Content", evt, evt.target);
		if (!this.UiModder.domClass.contains(evt.target, "matrixCell")) {
			return; // klick nicht auf eine zelle ausgeführt
		}
		let cellNode = evt.target;
		let contentEntry = this.getContentEntryByCellNode(cellNode);

		this.blurAllGroupContentCells(); // sobald etwas an der Selection geändert wurde, dann die Summenszellen unscharf schalten damit man sieht, dass dieser Wert nicht mehr stimmen muss
		this._handleContentCellSelection(contentEntry);
	}

	_handleContentSelection_Create(entity: DataItem_Content): void {

		this.blurAllGroupContentCells();
		this.selectionStateManager.addToStack(entity, "create");
		//let url = window.appRoot + "data/CreateSelection";
		//this.RequestManager.post(url,
		//	{
		//		"JsonData": JSON.stringify({
		//			"entity": entity
		//		})
		//	},
		//	lang.hitch(this, this.ContentSelection_Create_Response, entity),
		//	lang.hitch(this, this.ContentSelection_Create_Error)
		//);
	}

	_handleContentSelection_Delete(entity: DataItem_Content): void {

		this.selectionStateManager.addToStack(entity, "delete");
		//let url = window.appRoot + "data/DeleteSelection";
		//this.RequestManager.post(url,
		//	{
		//		"JsonData": JSON.stringify({
		//			"entity": entity
		//		})
		//	},
		//	lang.hitch(this, this.ContentSelection_Delete_Response),
		//	lang.hitch(this, this.ContentSelection_Delete_Error)
		//);
	}

	ContentSelection_Create_Response(originEntity: DataItem_Content, newEntity: DataItem_Content): void {
		originEntity.ID = newEntity.ID;
	}

	ContentSelection_Create_Error(error): void {
		alert(JSON.stringify(error));
	}

	ContentSelection_Delete_Response(response): void {

	}

	ContentSelection_Delete_Error(error): void {
		alert(JSON.stringify(error));
	}

	_onScroll_Content(evt): void {

		let scrollTop = this.y_Axis_ScrollContainer.scrollTop;
		let cellHeightWithBorder = this.cellHeight + this.getCellBorderHeight();

		let calculatedIndex = Math.round(scrollTop / cellHeightWithBorder);
		let itemIndex_firstItem = calculatedIndex;

		this.calcVisibleIds_Y(itemIndex_firstItem);

		//	scroll-sync asynchonisieren damit sich das nicht gegenseitig ausbremset wenn mit dem Mausrad gescrollt wird
		//
		setTimeout(lang.hitch(this, function () {
			this.y_Axis_ScrollContainer.scrollTop = this.y_Axis_ScrollContainer.scrollTop + (evt.wheelDelta * (-1) / 3);
		}), 200);


		if (this.__scrollTimeout) {
			clearTimeout(this.__scrollTimeout);
		}

		//this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
		//this.__scrollTimeout = setTimeout(lang.hitch(this, function () {
			this.mapDataToViewPort();
		//}), 50);

		//this._resetContentOpacity();
    }

	_onScroll_X(evt): void {
		let scrollLeft = evt.target.scrollLeft;
		let cellWithWithBorder = this.cellWidth + this.getCellBorderWidth();

		let calculatedIndex = Math.round(scrollLeft / cellWithWithBorder);
		let itemIndex_firstItem = calculatedIndex;

		let firstItem = this._registry_X[itemIndex_firstItem];
		let lastItem = this._registry_X[itemIndex_firstItem + this.maxCells];

		this.calcVisibleIds_X(itemIndex_firstItem);

		// scroll-step anpassen damit immer zu ganzem item gescrollt wird und nie nur ein halbes sichtbar ist
		// hier sollte noch das delty zum vorherigen scroll berechnet werden damit auch der klick auf den balken-pfeil geht
		//
		evt.target.scrollLeft = (itemIndex_firstItem) * cellWithWithBorder;

		if (this.OpacityScroll) {
			this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
		}

		if (this.__scrollTimeout) {
			clearTimeout(this.__scrollTimeout);
		}
		this.__scrollTimeout = setTimeout(lang.hitch(this, function () {
			this.mapDataToViewPort();
		}), 50);

		this._resetContentOpacity();
	}

	_onScroll_Y(evt): void {
		this.y_Axis.scrollTop = evt.target.scrollTop;
	}

	_onScroll_Y_direct(evt): void {
		let scrollTop = evt.target.scrollTop;
		let cellHeightWithBorder = this.cellHeight + this.getCellBorderHeight();

		let calculatedIndex = Math.round( scrollTop / cellHeightWithBorder);
		let itemIndex_firstItem = calculatedIndex;

		let firstItem = this._registry_Y[itemIndex_firstItem];
		let lastItem = this._registry_Y[itemIndex_firstItem + this.maxRows];

		this.calcVisibleIds_Y(itemIndex_firstItem);

		//	scroll-sync asynchonisieren damit sich das nicht gegenseitig ausbremset wenn mit dem Mausrad gescrollt wird
		//
		setTimeout(lang.hitch(this, function () {
			this.y_Axis_ScrollContainer.scrollTop = evt.target.scrollTop;
		}), 200);

		// scroll-step anpassen damit immer zu ganzem item gescrollt wird und nie nur ein halbes sichtbar ist
		// hier sollte noch das delty zum vorherigen scroll berechnet werden damit auch der klick auf den balken-pfeil geht
		//
		evt.target.scrollTop = (itemIndex_firstItem) * cellHeightWithBorder;

		if (this.__scrollTimeout) {
			clearTimeout(this.__scrollTimeout);
		}

		this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
		this.__scrollTimeout = setTimeout(lang.hitch(this, function () {
			this.mapDataToViewPort();
		}), 50);

		this._resetContentOpacity();
	}

	resetContentArea(): void {
		// der effektive rowindex ist der index der Zeilen im Content-bereich
		// dieser weicht vom visibleRoIndex ab weil diese durch ein/ausblenden der elemente verändert werden
		//
		let effectiveRowIndex = 0;

		//	alle sichtbaren Y-Items von oben nach unten durchlaufen
		//
		for (let visibleRowIndex = 0; visibleRowIndex < this._visibleItems_Y.length && effectiveRowIndex < this._visibleItems_Y.length; visibleRowIndex++) {
			let item_Y_check = this._visibleItems_Y[visibleRowIndex];
			let item_Y = this._visibleItems_Y[effectiveRowIndex];
			let row = this._registry[effectiveRowIndex];

			if (item_Y_check.invisible === true) {
				continue;
			}

			console.log("resetContentArea", item_Y_check.label, "visibleRowIndex", visibleRowIndex, "effectiveRowIndex", effectiveRowIndex, "originType", item_Y_check.type, "effectiveType", item_Y.type);


			// dann von links nach rechts die cells
			//
			let effectiveCellIndex = 0;
			for (let visibleCellIndex = 0; visibleCellIndex < row.cells.length; visibleCellIndex++) {

				let cellEntry = row.cells[effectiveCellIndex];
				let cellNode = cellEntry.cellNode;
				let item_X = this._visibleItems_X[visibleCellIndex];

				if (item_X?.invisible === true) {
					continue;
				}

				let selectionItem = this._getSelectionData(item_X, item_Y_check);

				if (selectionItem) {



					try {

						let cellNode = cellEntry.cellNode;
						cellNode.innerHTML = selectionItem.label;
						cellNode.style.background = selectionItem.color;
						cellEntry.entity = selectionItem;

						if (item_X.type == "group" || item_Y.type == "group") {
							cellEntry.type = "group"; // wenn X oder Y eine gruppe sind, dann ist der Schnittpunkt auch eine gruppe
						}

						this.UiModder.domClass.add(cellNode, "selected");

					} catch (ex) {
						//console.error(ex, "visibleIndex_Y", visibleIndex_Y, "visibleIndex_X", visibleIndex_X);
					}






				} else if (item_X) {
					if (item_X.type == "group" || item_Y_check.type == "group") {
						cellNode.innerText = "";
						cellNode.style.background = this.colors["group"];
						this.UiModder.domClass.add(cellNode, "selected");
					} else {
						cellNode.innerText = "";
						cellNode.style.background = "";
						this.UiModder.domClass.remove(cellNode, "selected");
					}

					cellEntry.entity = null;
				}

				effectiveCellIndex++;
			}

			effectiveRowIndex++;
		}
	}

	resetContentAreaV1(): void {
		for (let rowIndex = 0; rowIndex < this._registry.length; rowIndex++) {
			let row = this._registry[rowIndex];
			let item_Y = this._visibleItems_Y[rowIndex];

			if (item_Y == null) {
				return;
			}

			for (let cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {

				let cellEntry = row.cells[cellIndex];
				let cellNode = cellEntry.cellNode;
				let item_X = this._visibleItems_X[cellIndex];

				if (item_X) {
					if (item_X.type == "group" || item_Y.type == "group") {
						cellNode.innerText = "";
						cellNode.style.background = this.colors["group"];
						this.UiModder.domClass.add(cellNode, "selected");
					} else {
						cellNode.innerText = "";
						cellNode.style.background = "";
						this.UiModder.domClass.remove(cellNode, "selected");
					}
				}

				cellEntry.entity = null;
			}
		}
	}

	private _getSelectionData(pItem_X: DataItem_X, pItem_Y: DataItem_Y): DataItem_Content {

		if (!pItem_X || !pItem_Y) {
			return null;
		}

		for (let selectionItemIndex = 0; selectionItemIndex < this._data_Content.items.length; selectionItemIndex++) {
			let selectionEntity = this._data_Content.items[selectionItemIndex];

			if (selectionEntity.ref_x == pItem_X.ID && selectionEntity.ref_y == pItem_Y.ID) {
				return selectionEntity;
			}
		}
	}

	mapDataToViewPort(): void {
		if (this._data_Content == null) {
			return;
		}
		// alles alte löschen
		//
		this.resetContentArea();

		return;

		// alle SelectionItems durchlaufen und die sichtbaren rausholen
		//
		for (let selectionItemIndex = 0; selectionItemIndex < this._data_Content.items.length; selectionItemIndex++) {
			let selectionEntity = this._data_Content.items[selectionItemIndex];

			let visibleIndex_X = this._visibleIDs_X.indexOf(selectionEntity.ref_x);
			let visibleIndex_Y = this._visibleIDs_Y.indexOf(selectionEntity.ref_y);

			let item_X = this._visibleItems_X[visibleIndex_X];
			let item_Y = this._visibleItems_Y[visibleIndex_Y];


			/*if (item_Y?.invisible === true) {
				continue;
			}*/

			if (visibleIndex_X > -1 && visibleIndex_Y > -1 && (selectionEntity != null || typeof selectionEntity != "undefined" ) ) {
				try {
					let cellEntry = this._registry[visibleIndex_Y].cells[visibleIndex_X];
					let cellNode = cellEntry.cellNode;
					cellNode.innerHTML = selectionEntity.label;
					cellNode.style.background = selectionEntity.color;
					cellEntry.entity = selectionEntity;

					if (item_X.type == "group" || item_Y.type == "group") {
						cellEntry.type = "group"; // wenn X oder Y eine gruppe sind, dann ist der Schnittpunkt auch eine gruppe
					}

					this.UiModder.domClass.add(cellNode, "selected");

				} catch (ex) {
					//console.error(ex, "visibleIndex_Y", visibleIndex_Y, "visibleIndex_X", visibleIndex_X);
				}
			}
		}

	}

	destroyAllRows(): void {
		query(".matrixRow", this.containerNode).forEach(function (rowNode) {
			query(".matrixCell", this.containerNode).forEach(function (cellNode) {
				this.UiModder.domConstruct.destroy(cellNode);
			}, this);
			this.UiModder.domConstruct.destroy(rowNode);
		}, this);
	}

	getViewPortSize(): dojo.DomGeometryBox {
		if (!this.viewPortNode) {
			return null;
		}
		return domGeom.getMarginBox(this.viewPortNode);
	}

	getCellBoldBorderStyleString(position): any {
		return this.cellBorderBold[position] + "px " + this.cellBorderBold["style"] + " " + this.cellBorderBold["color"];
	}
	getCellBorderStyleString(position): any {
		return this.cellBorder[position] + "px " + this.cellBorder["style"] + " " + this.cellBorder["color"];
	}

	getCellBorderWidth(): number {
		return this.cellBorder["left"] + this.cellBorder["right"];
}

	getCellBorderHeight(): number {
		return this.cellBorder["top"] + this.cellBorder["bottom"];
	}

    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.inherited(arguments);

		this.openWeekSelector();

		this.selectionStateManager.placeAt(this.mainMenuGlobalSpaceNode);
		this.selectionStateManager.on("rollback", lang.hitch(this, this.selectionStateManager_Rollback));
		this.selectionStateManager.on("commit", lang.hitch(this, this.selectionStateManager_Commit));
		this.selectionStateManager.on("beforeCommit", lang.hitch(this, this.selectionStateManager_BeforeCommit));

		//	overflow vom body entfernen damit die ganze seite nicht am body scrollt
		//
		//window.document.body.style.overflow = "hidden";
    }
}

mdsLazyProto(OrchestraMatrix.prototype, {
  selectionStateManager: () => (new SelectionStateManager()),
});
export default mdsWidget(OrchestraMatrix);
